import * as React from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

function MUIButton({ btnStyle, btnOnClick, btnLabel, children, btnType="",isdisabled=false }) {
  return (
    <Button
      onClick={btnOnClick}
      type={btnType}
      variant="contained"
      sx={{ ...btnStyle, py: "6px", borderRadius: "10px", textTransform: "capitalize" }}
      disabled={isdisabled}
    >
      <span style={{ fontSize: "16px" }}>{btnLabel}</span>{" "}
      {children && children}
    </Button>
  );
}

export default MUIButton;
